module.exports = __webpack_public_path__ + "static/media/01.b2e89a1d.jpg";